export const GET_PARENT_CONTAINER_RECT = Symbol('getParentContainerRect');
export const GET_PADDING_VALUE = Symbol('getPaddingValue');
